import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
 // ✅ Import Helmet
import axios from 'axios';
import Preloader from '../common/preloader';
import HeadingSection from '../elementsui/HeadingSection';
import '../elementsui/DailyVegGrid.css';
import './CategoryDetail.css';
import BottomCartNav from '../Header/BottomCartNav';

const CategoryDetail = () => {
  const { category } = useParams();
  const [products, setProducts] = useState([]);
  const [selectedWeights, setSelectedWeights] = useState({});
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    const fetchCategoryProducts = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/api/products/category/${category}`);
        setProducts(res.data);
      } catch (err) {
        console.error('Error fetching category products:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchCategoryProducts();
  }, [category, API_BASE_URL]);

  const handleWeightChange = (index, label) => {
    const weightObj = products[index].weights.find((w) => w.weight === label);
    setSelectedWeights((prev) => ({ ...prev, [index]: weightObj }));
  };

  const handleAddToCart = async (product, selected) => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/login');
      return;
    }
    try {
      await axios.post(
        `${API_BASE_URL}/api/cart/add`,
        {
          productId: product._id,
          name: product.name,
          image: product.images[0],
          weight: selected.weight,
          price: selected.price,
          quantity: 1,
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
    } catch (error) {
      console.error('Error adding to cart:', error);
    }
  };

  const formattedCategory = category.charAt(0).toUpperCase() + category.slice(1);

  if (loading) return <Preloader />;

  if (!products || products.length === 0) {
    return (
      <div className="category-coming-soon-container text-center p-4">
        <Helmet>
          <title>{formattedCategory} - Coming Soon | binzal</title>
          <meta name="description" content={`We're working on bringing fresh ${formattedCategory} to your city with binzal.`} />
          <meta name="robots" content="noindex, follow" />
        </Helmet>

        <HeadingSection headingText={`Fresh ${formattedCategory} For You!`} />
        <img
          src="https://cdn.pixabay.com/photo/2018/01/22/19/09/coming-soon-3099715_1280.jpg"
          alt="Coming Soon"
          className="coming-soon-image img-fluid rounded"
          style={{ maxWidth: '400px', margin: '2rem auto' }}
        />
        <h3>Coming Soon!</h3>
        <p>We're preparing something fresh in this category. Stay tuned!</p>
      </div>
    );
  }

  return (
    <div className="veg-grid-wrapper">
      {/* ✅ SEO Helmet for dynamic category */}
      <Helmet>
        <title>Buy {formattedCategory} Online in Bihar | binzal</title>
        <meta name="description" content={`Order fresh ${formattedCategory} online from binzal. Fast home delivery in Patna, Gaya, Muzaffarpur & all Bihar cities.`} />
        <meta name="keywords" content={`buy ${category} online Bihar, ${formattedCategory} delivery Patna, shop ${category} binzal`} />
        <meta name="robots" content="noindex, follow" />
        <meta property="og:title" content={`Buy ${formattedCategory} Online in Bihar | binzal`} />
        <meta property="og:description" content={`Get high-quality ${formattedCategory} delivered quickly across Bihar with binzal.`} />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary" />
      </Helmet>

      <HeadingSection headingText={`Picked Up ${formattedCategory} For You!`} />
      <div className="veg-grid">
        {products.map((product, index) => {
          const selected = selectedWeights[index] || product.weights[0];
          return (
            <div key={product._id} className="veg-item">
              <div className="card veg-card text-center h-100 p-3">
                <img
                  src={product.images[0]}
                  alt={product.name}
                  className="mb-2 img-fluid rounded-3"
                />
                <h6 className="product-name">{product.name}</h6>
                <select
                  className="form-select weight-selector my-2"
                  value={selected.weight}
                  onChange={(e) => handleWeightChange(index, e.target.value)}
                >
                  {product.weights.map((w) => (
                    <option key={w.weight} value={w.weight}>
                      {w.weight}
                    </option>
                  ))}
                </select>
                <p className="price-original">₹ {selected.price}</p>
                <Link
                  to={`/product/${product._id}`}
                  className="mb-2 d-inline-flex text-decoration-none view-detail-link"
                >
                  View Detail <i className="bi bi-chevron-right ms-1"></i>
                </Link>

                <button
                  className="btn rounded px-3 mb-2 py-2 add-cart-btn"
                  onClick={() => handleAddToCart(product, selected)}
                >
                  <i className="bi bi-cart-plus me-2"></i>
                  <span>Add</span>
                </button>
              </div>
            </div>
          );
        })}
      </div>

      <BottomCartNav />
    </div>
  );
};

export default CategoryDetail;
